import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { AllPlayersService } from './all-players.service';

export const allPlayersServiceModule = angular.module('allPlayersServiceModule', [])
	.factory('allPlayersService', downgradeInjectable(AllPlayersService) as any)
	.name;
